import { withStyles } from '@material-ui/core/styles';
import Accordion from './Accordion';
import styles from './Accordion.styles';

export default withStyles(styles)(Accordion);
